import styled from 'styled-components';

import { basicBodyTextStyle, StyledFlex } from '@dreryk/react-components';

export const StyledVisitHistoryPatientPregnancyMark = styled(StyledFlex)`
   ${basicBodyTextStyle}
`;
StyledVisitHistoryPatientPregnancyMark.displayName = 'StyledVisitHistoryPatientPregnancyMark';
